import PropTypes from 'prop-types';

import { formatDocumentStatusLabel } from '#/modules/imsMgmt/receipts/shared/documentStatus';

import { StatusBadge } from './StatusBadge';

const DocumentStatusBadge = ({ status, size = 'default', className }) => (
  <StatusBadge
    status={status}
    label={formatDocumentStatusLabel(status)}
    size={size}
    className={className}
  />
);

DocumentStatusBadge.propTypes = {
  status: PropTypes.string,
  size: PropTypes.oneOf(['default', 'sm']),
  className: PropTypes.string,
};

export { DocumentStatusBadge };
